<template>
  <div>
    <div class="bootstrap-wrapper">
      <div class="container">
        <!--<div class="row" style="margin-bottom:20px;">
          <div class="col-md-12 nohover shadow" style="border-radius:4px;">
            <div class="map">
              <div class="title">
                <div style="display:flex;flex-direction:column;height:100%;justify-content:center;align-items:center;font-weight:bold;">{{ $root.data.info.name }}</div>
              </div>
  
              <gmap-map v-if="location" ref="map" :options="{disableDefaultUI:true}" mapTypeId="satellite" :center="location" :zoom="14" style="width: 100%; height: 100%;border-radius:4px;">
                <gmap-marker :position="location" :clickable="false" :draggable="false"></gmap-marker>
              </gmap-map>
            </div>
          </div>
        </div>-->


        <div class="row">
          <div class="col-md-8">hejsan</div>

          <div class="col-md-4 box">
            <strong>Mäta</strong>
            <table>
              <tbody>
                <tr v-for="item in sensors.slice(0, 4)">
                  <td>{{ item.name }}</td>
                  <td align="right">{{ item.value }}°C</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        
        <div class="row" style="margin-top:20px;">
          <div class="col-md-8">hejsan</div>

          <div class="col-md-4 box">
            <table>
              <tbody>
                <tr v-for="item in favoriteScenarios.slice(0, 3)">
                  <td><span :style="{ color: item.color }">&bull;	</span>{{ item.name }}</td>
                  <td align="right"><span :style="{ color: item.color }">Kör scenario</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import * as VueGoogleMaps from 'vue2-google-maps'

  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyD2JcbcYQfyrN_Rl5_D2TrOu5Kd59juy_4'
    }
  })
  
  export default {
    name: 'startpage',
    data: () => ({
      iconSize: 55
    }),
    created () {},
    methods: {
      go (item) {
        this.$router.push({
          name: item.id
        })
      },

      countCapAndValue (capability, comparator, value) {
        let count = 0
        this.$root.data.nodes.forEach(node => {
          if (node.capabilities.includes(capability) && capability in node.lastEvents) {
            const event = node.lastEvents[capability]
            if (comparator != undefined && value != undefined) {
                if (this.compare(event.value, comparator, value)) {
                  count++
              }
            } else {
              count++
            }
          }
        })
        
      
        return count
      },
      
      compare(value, comparator, to) {
        switch (comparator) {
          case '===': return value === to; break
          case '>': return value > to; break
        }
      }
    },
    
    computed: {
      sensors () {
        return this.$root.data.nodes
        .filter(x => x.capabilities.includes('temperature'))
        .filter(x => 'temperature' in x.lastEvents)
        .map(x => ({
          id: x.id,
          name: x.name,
          value: x.lastEvents.temperature.value,
          time: x.lastEvents.temperature.time,
          age: (new Date() - new Date(x.lastEvents.temperature.time)) / 1000,
          favorite: x.favorite || false
        }))
        //.sort((a, b) => b.favorite - a.favorite)
        .sort((a, b) => b.age - a.age)
      },

      favoriteScenarios () {
        return this.$root.data.scenarios
        .filter(x => x.favorite)
        .map(x => ({
          id: x.id,
          name: x.name,
          color: x.color
        }))
      },

      ok () {
        const motion = this.countCapAndValue('notificationMotion', '===', true)        
        const contact = this.countCapAndValue('notificationContact', '===', true)        
        const smoke = this.countCapAndValue('notificationSmoke', '===', true)        
        const water = this.countCapAndValue('notificationWater', '===', true)        

        return !(motion > 0 || contact > 0 || smoke > 0 || water > 0)
      },
      /*
        TODO: använd någon standardposition här, exempelvis Göteborg,
        så det inte blir en laddning.
      */
      location () {
        if ('location' in this.$root.data.info) {
          return {
            lat: this.$root.data.info.location.lat, 
            lng: this.$root.data.info.location.lon 
          }
        }
      }
    }
  }
</script>

<style scoped>
  div[class*="col-md-"] {
    margin:0px;
    padding:0px;
    transition:all 0.3s ease;
  }

  div[class*="col-md-"] .content, div[class*="col-md-"] .map {
    text-align: center;
    height:120px;
    border-radius: 4px;
    color:#FFF;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
  
      
  .map .title {
    position:absolute;
    height:100%;
    width:100%;
    z-index:1;
    color:#FFF;
    font-size:35px;
  }
  
  @media only screen and (min-width: 450px) {
    div[class*="col-md-"] .content, div[class*="col-md-"] .map {
      height:150px;
    }
    
    .map .title {
      position:absolute;
      height:100%;
      width:100%;
      z-index:1;
      color:#FFF;
      font-size:45px;
    }
  }
  
  div[class*="col-md-"] .content .head {
    font-size:16px;
  }

  .image {
    padding-bottom:10px;
  }

  div[class*="col-md-"] .content .descr {
    font-size:13px;
    color:rgba(255, 255, 255, 0.6)
  }

  div[class*="col-md-"]:not(.nohover):hover {
    cursor:pointer;
    -webkit-transform: scale(0.99);
    -ms-transform: scale(0.99);
    transform: scale(0.99);
  }

  .descr2 {
    font-size:12px;
    color:#fff;
    margin-top:0px;
  }
  
  .rotate {
    animation-name: spin;
    animation-duration: 20000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear; 
  }
    
  @keyframes spin {
    from {
      transform:rotate(0deg);
    }
    to {
      transform:rotate(360deg);
    }
  }

  .shadow {
box-shadow: 1px 1px 11px 0px rgba(0,0,0,0.45);
  }

  .box {
    box-shadow: 1px 1px 11px 0px rgba(0,0,0,0.25);
    padding:12px !important;
    border-radius:6px;
    font-size: 14px;
  }
</style>


// WEBPACK FOOTER //
// src/components/startpage2.vue